
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      default: null,
    },
    options: {
      type: Array,
      default: null,
    },
    subgroup: {
      type: Array,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    optionkey: {
      type: String,
      default: 'id',
    },
    name: {
      type: String,
      default: 'name',
    },
    placeholder: {
      type: String,
      default: 'Choose',
    },
    withIcon: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      open: false,
      modelValue: null,
    };
  },
  computed: {
    selectedName() {
      if (!this.value) return this.placeholder;
      const allOptions = [...(this.options || []), ...(this.subgroup || [])];
      const found = allOptions.find((c) => c[this.optionkey] === this.value);
      return found ? found[this.name] : this.placeholder;
    },
  },
  watch: {
    modelValue(value) {
      this.$emit('input', value);
    },
    value(value) {
      this.modelValue = value;
    },
  },
  mounted() {
    this.modelValue = this.value;
    this.$root.$on('single-select-opened', this.onOtherOpened);
  },
  beforeDestroy() {
    this.$root.$off('single-select-opened', this.onOtherOpened);
  },
  methods: {
    onLabelClick() {
      const willOpen = !this.open;
      if (willOpen) this.$root.$emit('single-select-opened', this.id);
      this.open = willOpen;
    },
    onOtherOpened(id) {
      if (id !== this.id) this.open = false;
    },
    closeDesktopSelect() {
      this.open = false;
    },
    emitDesktop(id) {
      this.$emit('input', id);
      this.open = false;
    },
  },
};
